import React, { Component } from "react";

import { MSection, Title } from "components/misc";
import { Row, Col } from "design-react-kit";
import { Helmet } from "react-helmet";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper/core";

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
SwiperCore.use([Pagination]);

export class PageLeoniSicani extends Component {
  render() {
    const title = 'LEONI SICANI APS ASD"';
    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </Helmet>
        <MSection>
          <Row>
            <Col>
              <Title>{title}</Title>
              <hr />
              <p>
                <strong>Regalare un sorriso.</strong> Era questo il desiderio
                dell’<strong>Associazione Mnemosine</strong> nei confronti dei{" "}
                <strong>
                  Leoni Sicani, la squadra di hockey su carrozzina
                </strong>{" "}
                che rappresenta il territorio agrigentino in ambito nazionale.
                Abbiamo, dunque, pensato di donar loro qualcosa che li avvicinasse sempre più alla libertà. Il primo sostegno reale
                e concreto donato ai Leoni Sicani è stato un pullman 22 posti con l’obiettivo di accompagnarli ovunque loro vorranno.
              </p>
              <p>
                La libertà di viaggiare dunque, di conoscere, di muoversi.
                E grazie al mezzo donato dal nostro ente, la squadra dei Leoni Sicani ha potuto partecipare alle trasferte
                del campionato italiano di Powerchair Hockey (l'hockey su carrozzina). L’associazione, inoltre, ha voluto donare
                il primo vero viaggio dei Leoni Sicani a Parigi, luogo nel quale i ragazzi hanno potuto
                fare esperienza concreta delle attrazioni turistiche più ambite: la Torre Eiffel, il tour sulla Senna, l’Euro Disney.
              </p>
              <p>
                <i>
                  Per me è stato un enorme orgoglio e piacere offrire una vacanza del genere ai ragazzi dei Leoni Sicani
                </i>{" "}
                - è quanto afferma il <strong>professore Nino Barbera</strong>,
                fondatore dell'Associazione Mnemosine - sono delle persone straordinarie e
                devo dire che il loro entusiasmo mi ha contagiato. Vorrei che il mio gesto fosse da stimolo
                per tutti coloro che hanno a disposizione determinate possibilità economiche,
                incentivando la loro attività di solidarietà a favore dei Leoni Sicani o nei confronti di realtà simili”.
              </p>
              <p>Nel 2020 abbiamo deciso di sostenere i Leoni con un progetto in cui abbiamo profondamente creduto.
                La realizzazione del Barbera Center, un centro sportivo polivalente totalmente accessibile in cui poter praticare,
                oltre all’hockey in carrozzina, anche calcio a 5 indoor, tennis indoor, basket e pallavolo.</p>
              <p>Nel 2021 abbiamo supportato ancora una volta i Leoni contribuendo all’acquisto di un pulmino 9 posti dotato
                di pedana elevatrice, aiutando, così, la squadra a completare la raccolta fondi online.</p>
              <p>Il numero degli atleti è aumentato nel corso di questi anni e le esigenze di un altro mezzo di
                trasporto sono diventate concrete. Per tale ragione abbiamo deciso di contribuire per soddisfare una loro necessità reale.
                Li abbiamo sostenuti per l’acquisto di un nuovo pulmino, ottenuto grazie alla partecipazione
                a un progetto promosso dalla Fondazione Prosolidar, al quale i Leoni Sicani hanno aderito.</p>
              <h3>
                Grazie a tutti i Corsisti dell'Associazione Mnemosine per aver
                contribuito a tutto questo.
              </h3>
              <p>
                L'Associazione "Leoni Sicani APS ASD" ha per oggetto l'esercizio e
                la promozione di attività sportive, culturali e ricreative per persone con disabilità,
                con particolare riferimento alla disciplina del Powerchair Hockey. L'hockey su carrozzina elettrica,
                nasce grazie ad un gruppo di giovani affetti da patologie neuromuscolari, seguendo già da tempo alcuni loro
                amici disabili impegnati in altre discipline,
                volevano rendersi anche loro protagonisti di uno sport che fosse adatto alle loro particolari esigenze.
              </p>
              <p>
                Aiutaci a sostenere le nostre attività, fai una donazione ai Leoni Sicani,
                Codice Iban: IT29C0898583140013010000834.
              </p>
              <p>
                Oppure, destina il tuo 5x1000 alla squadra, inserisci il codice fiscale 92020760846 nel riquadro
                "Sostegno degli enti del terzo settore iscritti nel RUNTS di cui all’art. 46, C. 1, del D.LGS. 3 luglio 2017,
                n.117, comprese le cooperative sociali
                ed escluse le imprese sociali costituite in forma di società, nonché sostegno delle Onlus iscritte all’anagrafe”.
              </p>
              <p>A te non costa nulla, per noi è un aiuto importante! I Leoni Sicani sono anche su facebook!
                Diventa membro del gruppo Leoni Sicani APS ASD e sarai aggiornato su tutte le attività della squadra!</p>
              <Swiper
                style={{ marginTop: "40px" }}
                navigation
                pagination={{
                  clickable: true,
                }}
              >
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/1.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/2.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/3.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/4.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/5.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/6.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <img
                    style={{ width: "100%", height: "auto" }}
                    src="/img/leoni-sicani/7.jpeg"
                    title="Leoni Sicani"
                    alt="Leoni Sicani"
                  />
                </SwiperSlide>
              </Swiper>
              {/* <section id="cinquepermille" style={{ marginTop: "40px" }}>
                <a
                  href="https://www.leonisicani.it/dona-il-tuo-5x1000/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/img/leoni-sicani/cinquepermille.jpeg"
                    alt="dona il tuo ciqnue per mille ai leoni sicani"
                  />
                </a>
              </section> */}
              <section id="cinquepermille_leoni">
                <h2 className="cinquepermille_leoni_title">
                  Dona il tuo 5×1000 ai Leoni Sicani <br /> CF 92020760846
                </h2>
                <br />
                <p className="cinquepermille_leoni_description">
                  Metti una firma nella tua dichiarazione dei redditi per i
                  LEONI SICANI e aiutaci a sviluppare e diffondere attività
                  solidali e di inclusione per persone diversamente abili
                </p>
                <div className="cinquepermille_leoni_image">
                  <img
                    className="w-80"
                    src="/img/pages/immagine-scheda-compilazione-5x1000.jpeg"
                    alt="modello cinque per mille"
                  />
                </div>
                <div className="cinquepermille_leoni_info">
                  <h3 className="cinquepermille_leoni_info_title">
                    Presentando il modello 730 o dei redditi
                  </h3>
                  <ul>
                    <li>Compila il modulo del modello 730 o redditi</li>
                    <li>
                      Nella sezione “SCELTA PER LA DESTINAZIONE DEL CINQUE PER MILLE DELL’IRPEF”
                      firma nella sezione del riquadro “SOSTEGNO DEGLI ENTI DEL TERZO SETTORE ISCRITTI AL RUNTS…”
                    </li>
                    <li>
                      Specifica il codice fiscale dei Leoni Sicani APS ASD:
                      92020760846{" "}
                    </li>
                  </ul>
                  <h3 className="cinquepermille_leoni_info_title">
                    Per donare il tuo 5x1000 anche se sei esonerato dalla
                    presentazione della dichiarazione dei redditi
                  </h3>
                  <ul>
                    <li>Compila la scheda CU (Certificazione Unica)</li>
                    <li>
                      Firma nella sezione del riquadro “SOSTEGNO DEGLI ENTI DEL TERZO SETTORE ISCRITTI AL RUNTS…”
                    </li>
                    <li>
                      Specifica il codice fiscale dei Leoni Sicani APS ASD:
                      92020760846
                    </li>
                  </ul>
                </div>
              </section>
            </Col>
          </Row>
        </MSection>
      </>
    );
  }
}
